import { createStyles } from '@material-ui/core/styles';
import { spacing } from '#web-components/styles/constants';

const styles = () => createStyles({
  root: {
    overflow: 'hidden',
    paddingTop: spacing + 4,
    paddingBottom: spacing + 4,
  },
  name: {
    display: 'inline',
    cursor: 'pointer',
  },
});

export default styles;
